import { isValid } from 'date-fns'
import { parseDate } from '../../../../../resources/Utils'
import serviceBase from '../../../../Services/serviceBase'

class TransactionsReportActions {
  getTransactionsReport = async (filterPayload) => {
    let url = `${
      window._env_.COMMUNITY_API_URL || 'https://communityapi-qa.iartest.com/api/v1'
    }/transaction-logs/get-list`
    return serviceBase.post(url, filterPayload).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  getDatesBetweenDates = (startDate, endDate) => {
    let dates = []
    const theDate = new Date(startDate)
    while (theDate < endDate) {
      dates = [...dates, new Date(theDate)]
      theDate.setDate(theDate.getDate() + 1)
    }
    return dates.length
  }

  searchTransactionLogs = (startDate, endDate) => {
    const validation = {
      result: true,
      message: ''
    }
    if (isValid(startDate) && isValid(endDate)) {
      const dateRange = this.getDatesBetweenDates(startDate, endDate)
      if (startDate.getTime() > endDate.getTime()) {
        validation.result = false
        validation.message = 'Start Date cannot be greater than End Date'
      } else if (dateRange > 30) {
        validation.result = false
        validation.message = 'Please provide a search no longer than 30 days'
      }
      return validation
    }
    validation.result = false
    validation.message = 'Provide valid value search dates'
    return validation
  }

  formatMovementDate = (localDate) => {
    const dateFormat = parseDate(localDate, 'HH:mm MMM dd, y')
    return dateFormat
  }

}

export default new TransactionsReportActions()
